import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from "react-bootstrap/Button";
import * as Yup from 'yup';
import { useState, useEffect } from 'react';
import { Card, FloatingLabel, Form } from 'react-bootstrap';
import useApi from '../hooks/use-api';
import LegalWarning from '../components/legalwarning';
import InsetAlert from '../components/insetalert';
import DotLoader from '../components/dotloader';
import styles from '../styles/auth-pages.module.css';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

function RecoverPassword({showLogin}){

    useEffect(() => {
        document.title = "MFP - Recover Password";
    },[]);

    const {error, postRequest} = useApi();
    const [showRecPassFailure, setRecPassFailure] = useState(0);

    const initialValues = {
        Username: ""
    };

    const validationSchema = Yup.object({
        Username: Yup.string().required("Required")
    });

    const {register, handleSubmit, formState: {errors, isSubmitting}} = useForm({
        defaultValues: initialValues,
        resolver: yupResolver(validationSchema)
    });

    const onSubmit = async (values) => {
        const [, status] = await postRequest("recoverpass", values);
        if (status !== 200) {
            setRecPassFailure(-1);
        } else {
            setRecPassFailure(1);
        }
    };

    return(
        <Row className={styles.authRow}>
                <Col xs={12} className={styles.authCol}>
                    <div className={styles.legalWrap}>
                        <div className={styles.legalDesktop}>
                            <LegalWarning />
                        </div>
                    </div>
                    <Card className={styles.authCard}>
                        <Card.Img className={styles.banner} variant="top" src="../KTMAHEADER.png" alt="Money Follows The Person Banner"/>
                        <Card.Body className={styles.cardBody}>
                            <h3 className={styles.title}>Recover Password</h3>
                            <p className={styles.subtitle}>
                                Password recovery is only available before a passkey is enrolled. Enter your username and, if password recovery is still allowed for that account, we will send instructions to the email address on file.
                            </p>
                            
                                <>
                                {
                                    error ? 
                                        showRecPassFailure === -1
                                        ? 
                                            <InsetAlert heading="Login Failed" error={error} style={{width: '100%'}} />
                                        : 
                                            null 
                                     : 
                                     showRecPassFailure === 1
                                        ? 
                                            <InsetAlert type="Success" heading="Success!" body="If password recovery is still available for this account, instructions have been sent to the email address on file." style={{width: '100%'}} />
                                        : null
                                }
                                </>
                            

                        <Form onSubmit={handleSubmit(onSubmit)}>
                            <FloatingLabel controlId="recover-username" label="Username" className='mb-3'>
                                <Form.Control
                                    type="text"
                                    placeholder="Username"
                                    autoComplete="username"
                                    isInvalid={!!errors.Username}
                                    disabled={isSubmitting}
                                    {...register("Username")}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.Username?.message}
                                </Form.Control.Feedback>
                            </FloatingLabel>
                            <div className={styles.actionRow}>
                                <Button variant='link' className='ps-0' disabled={isSubmitting} onClick={showLogin}>Login</Button>
                                <Button className={styles.primaryButton} variant="primary" type="submit" disabled={isSubmitting}>
                                    {isSubmitting ? <DotLoader ButtonStyle={true} /> : <>Submit</>}
                                </Button>
                            </div>
                        </Form>
                        </Card.Body>
                    </Card>
                    <details className={styles.legalMobile}>
                        <summary className={styles.legalMobileSummary}>Legal Warning</summary>
                        <div className={styles.legalMobileBody}>
                            <LegalWarning />
                        </div>
                    </details>
                </Col>
            </Row>
    )
}

export default RecoverPassword;
